import theme from 'theme_'
import styled from 'styled-components'
import { Font14 } from 'components/Typography'

export const WLANMainBody = styled.div`
  color: ${theme.colors.otterWarmBlack};
  max-width: 300px;
  margin: 0 auto;
  min-height: 596px;
  line-height: 1.5;
  display: inline-block;
  vertical-align: middle;
  padding-top: 200px;
`

export const WLANTextBody = styled.div`
  margin: 0 auto;
  gap: 10px;
  width: 100%;
`

export const WLANError = styled.div`
  color: ${theme.colors.error};
  margin: 0 auto;
  gap: 10px;
  width: 100%;
`

export const WLANTemplateName = styled.input<{ invalid?: boolean }>`
  margin: 0 0 ${theme.spacing.s};
  padding: 0 ${theme.spacing.s};
  height: 40px;
  margin-top: 15px;
  ${Font14};
  font-family: ${theme.fonts.base};
  line-height: 24px;
  color: ${theme.colors.otterWarmBlack};
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.moreGrey};
  border-radius: 8px;
  outline: none;
  width: 100%;
  caret-color: ${theme.colors.horizonOrange};

  ::placeholder {
    color: ${theme.colors.darkeyGrey};
  }

  :hover {
    border-color: ${theme.colors.darkeyGrey};
  }
  :active,
  :focus {
    border-color: ${theme.colors.horizonOrange};
  }
  :disabled {
    background-color: ${theme.colors.lighterGrey};
    pointer-events: none;
  }

  ${(p) => p.invalid && `border-color ${theme.colors.error};`};
`
